import { createRestConnectionForm } from "./rest-connection-form";
import { REST_WO_SWAGGER_SPEC } from "./rest-connection-specs";

/** REST API collection. Everything but the spec lives in `rest-connection-form.tsx`. */
const createApiCollection = createRestConnectionForm(REST_WO_SWAGGER_SPEC);
export { createApiCollection as CreateRestApiCollection };
